import React from "react";
import styles from "./ProvisionalCalendarMark.module.scss";

export const PROVISIONAL_CALENDAR_HINT =
    "Официальный производственный календарь на этот год ещё не опубликован. Выходные и нормы посчитаны " +
    "по Трудовому кодексу: праздники и их переносы с выходных, 31 декабря — выходной; переносы «мостиков» " +
    "из постановления правительства не учтены. Официальный календарь заменит его автоматически.";

/** Метка «по ТК» рядом с нормой месяца, пока на год нет официального производственного календаря */
export const ProvisionalCalendarMark: React.FC<{ className?: string }> = ({ className }) => (
    <span className={`${styles.mark} ${className ?? ""}`} data-tip={PROVISIONAL_CALENDAR_HINT}>
        по ТК
    </span>
);
